import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const Analytics = () => import('@/views/Analytics')
const About = () => import('@/views/About')
const Area = () => import('@/views/Area')
const UserAnalytics = () => import('@/views/UserAnalytics')
const Cases = () => import('@/views/Cases.vue')
const PendingCases = () => import('@/views/CasesPending.vue')
const RejectedCases = () => import('@/views/CasesRejected.vue')
const SingleCase = () => import('@/views/CaseSingle.vue')
const AddCase = () => import('@/views/CaseAdd.vue')
const EditCase = () => import('@/views/CaseEdit.vue')
const SpeciesList = () => import('@/views/SpeciesList');
const SpeciesEdit = () => import('@/views/SpeciesEdit');
// const ValidationDashboard = () => import('@/views/ValidationDashboard.vue')
const ExportCenter = () => import('@/views/ExportCenter.vue')
const MessageReport = () => import('@/views/MessageReport.vue')
const SmsRecharge = () => import('@/views/SmsRecharge.vue')

//Histograms
const CauseOfDisplacement = () => import('@/views/histograms/causeOfDisplacement.vue')
const Outcome = () => import('@/views/histograms/outcome.vue')
const Mortality = () => import('@/views/histograms/mortality.vue')
const Release = () => import('@/views/histograms/release.vue')
const Monthly = () => import('@/views/histograms/monthly.vue')
const Yearly = () => import('@/views/histograms/yearly.vue')
const Percentage = () => import('@/views/histograms/percentage.vue')

//Species Wise Report
const SpeciesWise = () => import('@/views/SpeciesWise.vue')

// Views - Pages
const Login = () => import('@/views/pages/Login')
const Resources = () => import('@/views/pages/Resources')
const PrivacyPolicy = () => import('@/views/pages/PrivacyPolicy')
const ChildSafetyStandards = () => import('@/views/pages/ChildSafetyStandards')


//AK Defined

const new_entry = () => import('@/views/NewEntry')
const trips = () => import('@/views/Trips')
const singletrip = () => import('@/views/SingleTrip')
const map = () => import('@/views/Map.vue')
const users = () => import('@/views/Users.vue')
const deleted_users = () => import('@/views/DeletedUsers.vue')
const setting = () => import('@/views/Settings.vue')




Vue.use(Router)

let router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: '',
      component: TheContainer,
      meta : { requiresAuth : true },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta : {
            title : 'Dashboard | Wildlife Trust of India'
          },
        },
        {
          path: 'analytics',
          name: 'Analytics',
          component: Analytics,
          meta : {
            title : 'Analytics | Wildlife Trust of India'
          },
        },
        {
          path: 'user-analytics',
          name: 'User Analytics',
          component: UserAnalytics,
          meta : {
            title : 'User Analytics | Wildlife Trust of India'
          },
        },
        {
          path : 'map',
          props : true,
          name : 'Map',
          meta : {
            title : 'Map | Wildlife Trust of India'
          },
          component : map,
        },
        {
          path : 'trips',
          name : 'Treks',
          meta : {
            title : 'View & Edit Treks | Wildlife Trust of India'
          },
          component : trips
        },
        {
          path : 'users',
          name : 'Users',
          meta : {
            title : 'View & Edit Users | Wildlife Trust of India'
          },
          component : users
        },
        {
          path : 'deleted-users',
          name : 'Deleted Users',
          meta : {
            title : 'Deleted Users | Wildlife Trust of India'
          },
          component : deleted_users
        },
        {
          path : 'data-entry',
          name : 'Data Entry',
          meta : {
            title : 'Data Entry | Wildlife Trust of India'
          },
          component : new_entry
        },
        {
          path : 'settings',
          name : 'Settings',
          meta : {
            title : 'Settings | Wildlife Trust of India'
          },
          component : setting
        },
        {
          path : 'about',
          name : 'About',
          meta : {
            title : 'About | Wildlife Trust of India'
          },
          component : About
        },
        {
          path : 'trips/:id',
          props : true,
          name : 'Trek',
          meta : {
            title : 'View & Edit Trek | Wildlife Trust of India'
          },
          component : singletrip,
        },
        {
          path : 'area',
          name : 'Area',
          meta : {
            title : 'Manage Area | Wildlife Trust of India'
          },
          component : Area
        },
        {
          path : 'existing-cases',
          name : 'Existing Cases',
          meta : {
            title : 'View & Edit Existing Cases | Wildlife Trust of India'
          },
          component : Cases
        },
        {
          path : 'incomplete-cases',
          name : 'Incomplete Cases',
          meta : {
            title : 'View & Edit Incomplete Cases | Wildlife Trust of India'
          },
          component : PendingCases
        },
        // {
        //   path : 'validation-dashboard',
        //   name : 'Validation Dashboard',
        //   meta : {
        //     title : 'Validation Dashboard | Wildlife Trust of India'
        //   },
        //   component : ValidationDashboard
        // },
        {
          path : 'export-center',
          name : 'Export Center',
          meta : {
            title : 'Export Center | Wildlife Trust of India'
          },
          component : ExportCenter
        },
        {
          path : 'message-report',
          name : 'SMS Report',
          meta : {
            title : 'SMS Message Report | Wildlife Trust of India'
          },
          component : MessageReport
        },
        {
          // Intentionally not added to _nav.js — dev-only URL, not surfaced in the sidebar.
          path : 'sms-recharge',
          name : 'SMS Recharge',
          meta : {
            title : 'SMS Recharge | Wildlife Trust of India'
          },
          component : SmsRecharge
        },
        {
          path : 'rejected-cases',
          name : 'Rejected Cases',
          meta : {
            title : 'View & Edit Rejected Cases | Wildlife Trust of India'
          },
          component : RejectedCases
        },
        {
          path : 'existing-case/:id',
          props : true,
          name : 'Existing Case',
          meta : {
            title : 'View & Edit Case | Wildlife Trust of India'
          },
          component : SingleCase,
        },
        {
          path : 'add-new-case',
          props : true,
          name : 'Add New Case',
          meta : {
            title : 'Add New Case | Wildlife Trust of India'
          },
          component : AddCase,
        },
        {
          path : 'edit-case/:id',
          props : true,
          name : 'Edit Case',
          meta : {
            title : 'Edit Case | Wildlife Trust of India'
          },
          component : EditCase,
        },
        {
          path : 'histograms/cause-of-displacement',
          props : true,
          name : 'Cause of Displacement',
          meta : {
            title : 'Cause Of Displacement | Histogram | Wildlife Trust of India'
          },
          component : CauseOfDisplacement,
        },
        {
          path : 'histograms/outcome',
          props : true,
          name : 'Outcome Data Analysis',
          meta : {
            title : 'Outcome | Histogram | Wildlife Trust of India'
          },
          component : Outcome,
        },
        {
          path : 'histograms/mortality',
          props : true,
          name : 'Mortality Data Analysis',
          meta : {
            title : 'Mortality | Histogram | Wildlife Trust of India'
          },
          component : Mortality,
        },
        {
          path : 'histograms/release',
          props : true,
          name : 'Release Data Analysis',
          meta : {
            title : 'Release | Histogram | Wildlife Trust of India'
          },
          component : Release,
        },
        {
          path : 'histograms/monthly',
          props : true,
          name : 'Monthly Data Analysis',
          meta : {
            title : 'Monthly | Histogram | Wildlife Trust of India'
          },
          component : Monthly,
        },
        {
          path : 'histograms/yearly',
          props : true,
          name : 'Yealry Data Analysis',
          meta : {
            title : 'Yearly | Histogram | Wildlife Trust of India'
          },
          component : Yearly,
        },
        {
          path : 'histograms/percentage',
          props : true,
          name : 'Mortality & Release Percentage',
          meta : {
            title : 'Mortality & Release Percentage | Wildlife Trust of India'
          },
          component : Percentage,
        },
        {
          path : 'species-wise',
          props : true,
          name : 'Species Wise Report',
          meta : {
            title : 'Species Wise Report | Wildlife Trust of India'
          },
          component : SpeciesWise,
        },     
        {
          path : 'species-list',
          props : true,
          name : 'Available species in database',
          meta : {
            title : 'Species List | Wildlife Trust of India'
          },
          component : SpeciesList,
        },      
        {
          path : 'edit-species/:id',
          props : true,
          name : 'Edit Species',
          meta : {
            title : 'Edit Species | Wildlife Trust of India'
          },
          component : SpeciesEdit,
        },      
        {
          path : 'add-species',
          props : true,
          name : 'Add Species',
          meta : {
            title : 'Add Species | Wildlife Trust of India'
          },
          component : SpeciesEdit,
        },       
      ]
    },
    {
      path : '/login',
      name : 'Login',
      meta : {
        title : 'SaveAnimals | Wildlife Trust of India'
      },
      component : Login      
    },
    {
      path : '/privacy-policy',
      name : 'PrivacyPolicy',
      meta : {
        title : 'Privacy Policy | SaveAnimals.in | Wildlife Trust of India'
      },
      component : PrivacyPolicy
    },
    {
      path : '/child-safety-standards',
      name : 'ChildSafetyStandards',
      meta : {
        title : 'Child Safety Standards | SaveAnimals'
      },
      component : ChildSafetyStandards
    },
    // {
    //   path : '/download',
    //   name : 'Resources',
    //   component : Resources,
    //   meta : {
    //     title : 'Himachal Pradesh Forest Department | Wildlife Trust of India'
    //   },
    // },
    
  ]
}

router.beforeEach((to, from, next) => {

  // check if the route requires authentication and user is not logged in
  if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
    // redirect to login page
    next({ name: 'Login' })
    return
  }

  // if logged in redirect to dashboard
  if (to.path === '/login' && store.state.isLoggedIn) {
    next({ name: '' })
    return
  }

    
  next()
})

export default router;
